module.exports = __webpack_public_path__ + "img/no-users.cab2d5cc.svg";